import { GA4_EVENT } from "./event";
import { generateSHA256Hash } from "../hashEmail";

const dataLayerPush = (ga4Params, eventCallback) => {
    if (eventCallback && typeof eventCallback === "function") {
        ga4Params = {
            ...ga4Params,
            'eventCallback': eventCallback,
        }
    }

    window['dataLayer'] && window["dataLayer"].push(ga4Params);
}

export const sendAddShipmentTemplateEvent = (ga4Params) => {
    dataLayerPush({
        'event': GA4_EVENT.ADD_SHIPMENT_TEMPLATE,
        'template': ga4Params["template"],
    })
}

export const sendProductsChangeApprovalStatusEvent = (ga4Params) => {
    dataLayerPush({
        'event': GA4_EVENT.PRODUCTS_CHANGE_APPROVAL_STATUS,
        'approval_status': ga4Params["approval_status"],
        'quantity': ga4Params["quantity"],
    })
}

export const sendProductsDetailUpdateEvent = (ga4Params) => {
    dataLayerPush({
        'event': GA4_EVENT.PRODUCTS_DETAILS_UPDATE,
        'update_area': ga4Params["update_area"],
        'update_tab': ga4Params["update_tab"],
    })
}

export const sendProductsDeletedEvent = (ga4Params) => {
    dataLayerPush({
        'event': GA4_EVENT.PRODUCTS_DELETED,
        'quantity': ga4Params["quantity"],
    })
}

export const sendProductListFilterEvent = (ga4Params) => {
    dataLayerPush({
        'event': GA4_EVENT.PRODUCT_LIST_FILTER,
        'urun_adi': ga4Params["product_name"],
        'stok_kodu': ga4Params["stock_code"],
        'katalog_id': ga4Params["catalog_id"],
        'gtin': ga4Params["gtin"],
        'model_kodu': ga4Params["model_code"],
        'urun_kodu': ga4Params["product_code"],
        'kategori_sec': ga4Params["category"],
        'marka_sec': ga4Params["brand"],
    })
}

export const sendViewProductDealsEvent = (ga4Params) => {
    dataLayerPush({
        'event': GA4_EVENT.VIEW_PRODUCT_DEALS,
        'deal_status': ga4Params["deal_status"],
        'user_id': ga4Params["user_id"],
    })
}

export const sendSearchProductEvent = (ga4Params) => {
    dataLayerPush({
        'event': GA4_EVENT.SEARCH_PRODUCT,
        'search_term': ga4Params,
    })
}
export const sendProductFilteredSearchEvent = (ga4Params) => {
    dataLayerPush({
        'event': GA4_EVENT.PRODUCT_FILTERED_SEARCH,
        'kategori_sec': ga4Params["kategori_sec"],
        'marka_sec': ga4Params["marka_sec"],
    })
}
export const sendOpenProductForSaleEvent = (ga4Params) => {
    dataLayerPush({
        'event': GA4_EVENT.OPEN_PRODUCT_FOR_SALE,
        'successCount': ga4Params,
    })
}
export const sendProductLinkClickEvent = () => {
    dataLayer.push({
        'event': GA4_EVENT.PRODUCT_LINK_CLICK,
    })
}
export const sendUserInfo = async (ga4Params) => {
    const hashedEmail = await generateSHA256Hash(ga4Params.email);
    dataLayer.push({
      user_id: ga4Params.sellerId,
      hashedEmail: hashedEmail,
    });
}
